import { ApplicationState } from '@mews-commander/types';
import { isRoleManagementEnabled } from '@mews-commander/legacy-entities/src/ducks/subscriptions';
import { getCurrentEnterpriseSubscriptionId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { canCurrentProfileManageEnterpriseEmployees } from '@mews-commander/legacy-entities/src/selectors/session/scope';

export const canManagePortfolioRoles = (state: ApplicationState) => {
    const subscriptionId = getCurrentEnterpriseSubscriptionId(state);
    return (
        isCurrentEnterprisePortfolio(state) &&
        canCurrentProfileManageEnterpriseEmployees(state) &&
        isRoleManagementEnabled(state, { subscriptionId })
    );
};

export const canManageRoles = (state: ApplicationState) => {
    const subscriptionId = getCurrentEnterpriseSubscriptionId(state);
    return canCurrentProfileManageEnterpriseEmployees(state) && isRoleManagementEnabled(state, { subscriptionId });
};
